// src/components/intake/IntakeCountryPicker.js
//
// Ticket 064, amendment 2. A small searchable multi-select of countries (no
// dependency). A text box filters the list; each match is a checkbox row; chosen
// countries show as chips that can be removed. Options come from COUNTRY_OPTIONS
// (sharedOptions; Spain is not in it). `selected` is an array of ISO codes.

import React, { useState } from 'react'
import { COUNTRY_OPTIONS } from '../../lib/intake/intakeConfig'

export default function IntakeCountryPicker({ selected, onChange, label }) {
  const [query, setQuery] = useState('')
  const q = query.trim().toLowerCase()
  const matches = q ? COUNTRY_OPTIONS.filter((c) => c.label.toLowerCase().includes(q) || c.value.toLowerCase() === q) : COUNTRY_OPTIONS
  const nameOf = (code) => (COUNTRY_OPTIONS.find((c) => c.value === code) || { label: code }).label

  function toggle(code, on) {
    const next = on ? [...selected, code] : selected.filter((c) => c !== code)
    onChange([...new Set(next)].sort())
  }

  return (
    <div className="intake-country-picker">
      {selected.length > 0 && (
        <ul className="intake-chips" aria-label="Chosen countries">
          {selected.map((code) => (
            <li key={code} className="intake-chip">
              {nameOf(code)}
              <button type="button" className="intake-chip-remove" aria-label={`Remove ${nameOf(code)}`} onClick={() => toggle(code, false)}>×</button>
            </li>
          ))}
        </ul>
      )}
      <input
        type="text"
        className="profile-input"
        aria-label={label}
        placeholder="Type to search countries"
        autoComplete="off"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      <div className="intake-country-list" role="group" aria-label={label}>
        {matches.length === 0 && <p className="intake-hint-line">No country matches that search.</p>}
        {matches.map((c) => (
          <label key={c.value} className="cal-checkbox-label intake-checkbox-label">
            <input type="checkbox" checked={selected.includes(c.value)} onChange={(e) => toggle(c.value, e.target.checked)} />
            {c.label}
          </label>
        ))}
      </div>
    </div>
  )
}
